import AssetList from './assetList'
export default AssetList
